import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/selects/NoItemMessage.tsx
var n = e((e, n) => {
	let { noItemMessage: r, className: i, ...a } = e;
	return r ? /* @__PURE__ */ t("ul", {
		...a,
		className: i,
		ref: n,
		role: "menu",
		children: /* @__PURE__ */ t("li", {
			className: "no-item-message disabled",
			role: "presentation",
			children: /* @__PURE__ */ t("a", {
				role: "menuitem",
				children: /* @__PURE__ */ t("i", { children: r })
			})
		})
	}) : null;
});
//#endregion
export { n as default };

//# sourceMappingURL=NoItemMessage.js.map